<template>
  <el-dialog :visible="visible" :title="title" custom-class="with-title" @close="hide">
    <div v-loading="loading">
      <div class="dialog-content">
        <div class="message message-warning" v-if="campaign.type !== 'old_web_instantwin'">
          1人の応募者につき、応募グループは1件までです。
          <br />
          複数の応募グループに対して応募があった場合は、最初の応募が優先されます。
        </div>
        <div class="message message-warning mt-x1" v-if="campaign.type !== 'old_web_instantwin'">
          応募キーワードがキャンペーンポストの長文で省略される部分にあると、正しく振り分けられません。
          <br />
          詳しくは<a href="https://help-atelu.comnico.jp/about-long-tweets" target="_blank" rel="noopener noreferrer"
            >こちら</a
          >をご確認ください。
        </div>
        <div class="message message-warning" v-if="campaign.type === 'old_web_instantwin'">
          応募者は対象キャンペーンで最後に応募した内容で応募グループに振り分けられます。
          <br />
          同じ応募者が複数回応募した場合には、キャンペーン期間中に含まれる応募グループが切り替わる可能性があります。
        </div>

        <div class="caption">基本情報</div>
        <div class="setting-content">
          <Panel>
            <div class="input-container">
              <div class="label">
                応募グループ名
                <span class="badge badge-danger twitter ml-x1"> 必須 </span>
              </div>
              <div class="input">
                <el-input
                  placeholder="あたり:キーワードA, はずれ:キーワードB など"
                  maxlength="120"
                  :class="{ success: campaignPrize.name.length > 0 }"
                  type="text"
                  v-model="campaignPrize.name"
                  tabindex="1"
                />
              </div>
              <div class="error-container">
                <div v-if="isCheckEmptyNameText" class="title-input-error">テキストを入力してください。</div>
              </div>
            </div>
          </Panel>
        </div>
        <!-- 応募キーワード-->
        <div class="setting-content">
          <Panel>
            <div class="input-container">
              <div class="label mb-x2">応募キーワード</div>
              <div class="label">
                キャンペーンポストに以下のキーワードを含む
                <el-tooltip v-if="isCampaignPostKeywordTarget" placement="top">
                  <div slot="content">
                    この応募グループへの応募を判定するキーワードを入力してください。<br />
                    判定の対象は、応募収集URLの設定で登録したキャンペーンポストです。<br />
                    複数の応募グループに同じキーワードがセットされている場合、ランダムで振り分けられます。
                  </div>
                  <i class="mdi mdi-help-circle ml-x1" />
                </el-tooltip>
                <el-tooltip
                  v-else-if="campaign.type !== 'old_web_instantwin'"
                  placement="top"
                  content="この応募グループへの応募を判定するキーワードを入力してください。複数の応募グループに同じキーワードがセットされている場合、ランダムで振り分けられます。"
                >
                  <i class="mdi mdi-help-circle ml-x1" />
                </el-tooltip>
                <el-tooltip v-else placement="top" content="応募を判定するキーワードを入力してください。">
                  <i class="mdi mdi-help-circle ml-x1" />
                </el-tooltip>
              </div>
              <div class="input keyword-list">
                <div class="label-keyword mr-x1">全て含む</div>
                <tag-input :tags="searchKeyword" :disabled="true" add-tag-text="キーワード追加" v-if="searchKeyword" />
                <tag-input
                  :tags="campaignPrize.entryKeywords"
                  :onChange="onChangeEntryKeywords"
                  add-tag-text="キーワード追加"
                  :disabled="isCampaignFinished"
                />
              </div>
              <div class="input keyword-list mt-x1" v-if="orKeyword && orKeyword.length">
                <div class="label-keyword mr-x1">いずれか含む</div>
                <tag-input :tags="orKeyword" :disabled="true" add-tag-text="キーワード追加" />
              </div>
            </div>
            <div class="input-container" v-if="isIncludeQuoteTweets">
              <div class="label">
                {{ quoteKeywordText }}
                <el-tooltip placement="top" content="以下のキーワードを含む引用を、この応募グループに振り分けます。">
                  <i class="mdi mdi-help-circle ml-x1" />
                </el-tooltip>
              </div>
              <div class="input keyword-list">
                <tag-input
                  :tags="campaignPrize.commentKeywords"
                  :onChange="onChangeCommentKeywords"
                  :disabled="isCampaignFinished"
                  add-tag-text="キーワード追加"
                />
              </div>
            </div>
          </Panel>
        </div>
        <!-- WEBインスタントウィン-->
        <div class="setting-content" v-if="campaign.type === 'old_web_instantwin'">
          <Panel>
            <!-- 期間-->
            <div class="input-container">
              <div class="label">
                期間
                <el-tooltip
                  placement="top"
                  content="応募の収集期間を指定できます。何も指定しない場合、期間 = キャンペーン期間となります。"
                >
                  <i class="mdi mdi-help-circle"></i>
                </el-tooltip>
              </div>
              <div class="input mb-x2">
                <el-date-picker
                  placeholder="開始日"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="datePickerOption"
                  prefix-icon="mdi mdi-calendar-today"
                  :editable="false"
                  ref="startDate"
                  tabindex="2"
                  v-model="startDate"
                  :disabled="isCampaignFinished"
                ></el-date-picker>
                <el-time-select
                  class="ml-x2"
                  placeholder="開始時間"
                  :picker-options="timePicker"
                  prefix-icon="mdi mdi-clock"
                  :editable="false"
                  ref="startTime"
                  tabindex="3"
                  v-model="startTime"
                  :disabled="isCampaignFinished"
                  @focus="
                    () => {
                      isSelectingStartTime = true
                    }
                  "
                ></el-time-select
                ><span class="ml-x2">以降</span>
                <div class="input-invalid-text" v-if="errors.notInputStartDate">開始日を入力してください。</div>
                <div class="input-invalid-text" v-if="errors.lessThanCurrentTime">
                  開始日時は、現在日時より後を指定してください。
                </div>
              </div>
              <div class="input">
                <el-date-picker
                  placeholder="終了日"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="datePickerOption"
                  prefix-icon="mdi mdi-calendar-today"
                  :editable="false"
                  ref="endDate"
                  tabindex="4"
                  v-model="endDate"
                  :disabled="isCampaignFinished"
                ></el-date-picker>
                <el-time-select
                  class="ml-x2"
                  placeholder="終了時間"
                  :picker-options="timePicker"
                  prefix-icon="mdi mdi-clock"
                  :editable="false"
                  ref="endTime"
                  tabindex="5"
                  v-model="endTime"
                  :disabled="isCampaignFinished"
                  @focus="
                    () => {
                      isSelectingStartTime = false
                    }
                  "
                ></el-time-select
                ><span class="ml-x2">未満</span>
                <div class="input-invalid-text" v-if="errors.notInputEndDate">終了日を入力してください。</div>
                <div class="input-invalid-text" v-if="errors.lessThanStartTime">
                  終了日時は、開始日時より後を指定してください。
                </div>
                <div class="input-invalid-text" v-if="errors.lessThanCurrentTimeForEnd">
                  終了日時は、現在日時より後を指定してください。
                </div>
              </div>
            </div>
            <!-- 1日の切り替え時間-->
            <div class="input-container">
              <div class="label">
                1日の切り替え時間
                <el-tooltip placement="top">
                  <div slot="content">1日の当選数をリセットする時間を設定できます。</div>
                  <i class="mdi mdi-help-circle" />
                </el-tooltip>
              </div>
              <el-time-select
                placeholder="時間"
                :picker-options="timePickerOption"
                prefix-icon="mdi mdi-clock"
                :editable="false"
                tabindex="6"
                v-model="campaignPrize.dailyWinnerChangeTime"
                :disabled="isCampaignFinished"
              />
            </div>
          </Panel>
        </div>
        <!-- 当選数-->
        <div class="setting-content">
          <Panel>
            <div class="input-container mb-x2">
              <div class="label">
                当選数
                <el-tooltip
                  v-if="campaign.type !== 'old_web_instantwin'"
                  placement="top"
                  content="応募に当選者を設定する場合、当選数を入力してください。外れ応募とする場合、0を入力してください。"
                >
                  <i class="mdi mdi-help-circle ml-x1" />
                </el-tooltip>
              </div>
              <el-input-number
                controls-position="right"
                v-model="campaignPrize.maxWinnerCount"
                :min="0"
                :max="99999"
                tabindex="2"
                :step="1"
                @change="onChangeMaxWinnerCount"
              />
            </div>
            <div class="input-container mb-x2" v-if="campaign.type === 'old_web_instantwin'">
              <div class="label">
                1日の最大当選数(0 = 制限なし)
                <el-tooltip placement="top" content="一日の最大当選数を設定できます。(最終日を除く)">
                  <i class="mdi mdi-help-circle ml-x1" />
                </el-tooltip>
              </div>
              <el-input-number
                controls-position="right"
                v-model="campaignPrize.dailyWinnerCount"
                :min="0"
                :max="99999"
                tabindex="2"
                :step="1"
                @change="onChangeDailyWinnerCount"
                :disabled="isCampaignFinished"
              />
            </div>
            <div class="input-container mb-x2" v-if="campaign.type === 'old_web_instantwin'">
              <div class="label">当選率変動</div>
              <el-radio
                border
                label="none"
                v-model="campaignPrize.winningRateChangeType"
                :disabled="isCampaignFinished"
              >
                変動なし
              </el-radio>
              <el-tooltip
                placement="top"
                content="当選数が全てはけるように、残り時間と残り当選数に応じて当選率を調整します。"
              >
                <el-radio
                  border
                  label="auto"
                  v-model="campaignPrize.winningRateChangeType"
                  :disabled="isCampaignFinished"
                >
                  自動変動
                </el-radio>
              </el-tooltip>
            </div>
            <div
              class="input-container"
              v-if="campaign.type === 'old_web_instantwin' && campaignPrize.winningRateChangeType !== 'auto'"
            >
              <div class="label">当選率(%)</div>
              <el-input-number
                controls-position="right"
                v-model="campaignPrize.winningRate"
                :min="0"
                :max="100"
                tabindex="2"
                :step="1"
                @change="onChangeWinningRate"
                :disabled="isCampaignFinished"
              />
            </div>
          </Panel>
        </div>
        <!-- 1日1回抽選-->
        <div class="setting-content" v-if="campaign.type === 'old_web_instantwin'">
          <Panel>
            <div class="input-container">
              <el-switch
                v-model="campaignPrize.isDailyLottery"
                active-text="1日1回抽選"
                :active-value="1"
                :inactive-value="0"
              />
              <el-tooltip
                placement="top"
                content="ONにすると、1日の切り替え時間を経過後、このキャンペーンで当選履歴のない応募者で再度指定アクションを実施した人の中から抽選します。"
              >
                <i class="mdi mdi-help-circle"
              /></el-tooltip>
            </div>
          </Panel>
        </div>

        <!-- 抽選メディア・テキスト関連 -->
        <div v-if="campaign.type === 'old_web_instantwin'" class="campaign-create-condition web-instanwin-page">
          <Panel>
            <div class="input-container">
              <div class="label mb-x1">
                <span>抽選中メディア</span>
                <el-tooltip placement="top">
                  <div slot="content">
                    抽選中に表示するメディアを選択できます。<br />
                    未設定の場合、デフォルトのGIF動画が表示されます。<br />
                    画像の場合は3秒間、動画の場合は動画の再生が完了するまで表示し、抽選結果のページに遷移します。
                  </div>
                  <i class="mdi mdi-help-circle"></i>
                </el-tooltip>
              </div>
              <div
                class="web-instanwin-page-media"
                v-loading="isLoading"
                element-loading-text="画像/動画をアップロードしています。 しばらくお待ちください。"
              >
                <el-button
                  v-if="!campaignPrize.pageLoadingMediaUrl"
                  type="primary"
                  @click="$refs.loadingMediaRef.click()"
                >
                  アップロード
                </el-button>
                <div v-if="campaignPrize.pageLoadingMediaUrl">
                  <div class="media-preview" :class="{ 'disabled-media': isCampaignFinished }">
                    <i class="mdi mdi-close" @click="removeMedia"></i>
                    <div class="media-name">{{ campaignPrize.pageLoadingMediaOriginName }}</div>
                    <video
                      v-if="isUploadMediaLoadingType"
                      :src="campaignPrize.pageLoadingMediaUrl"
                      class="direct-media mt-x2"
                      controls
                    ></video>
                    <img v-else :src="campaignPrize.pageLoadingMediaUrl" class="direct-media mt-x1" />
                  </div>
                  <div v-if="!isCampaignFinished" class="mt-x2">
                    <label class="el-button el-button--default" @click="$refs.loadingMediaRef.click()">
                      <i class="mdi mdi-image"></i>
                      <span v-if="campaignPrize.pageLoadingMediaUrl">画像/動画を変更</span>
                    </label>
                  </div>
                </div>
                <span v-if="!isCampaignFinished" class="media-limit-text"
                  >アップロード可能最大サイズ: 画像5MB 動画25MB</span
                >
                <input
                  type="file"
                  style="display: none"
                  @change="handleFileChange($event)"
                  accept="video/mp4,image/jpeg,image/png,image/pjpeg,image/gif"
                  ref="loadingMediaRef"
                />
              </div>
            </div>
            <div class="input-container">
              <div class="label mb-x1">
                <span>抽選中テキスト</span>
                <span class="badge badge-danger ml-x1">必須</span>
              </div>
              <el-input
                v-model="campaignPrize.pageLoadingText"
                id="text"
                type="textarea"
                class="body-textarea"
                :rows="10"
                placeholder="内容を入力"
                :disabled="isCampaignFinished"
              />
            </div>
            <div class="error-container">
              <div class="empty-label"></div>
              <div v-if="isCheckEmptyLoadingText" class="title-input-error">テキストを入力してください。</div>
            </div>
          </Panel>
        </div>
      </div>

      <div class="dialog-footer" slot="footer">
        <div v-if="!campaignPrize.id">
          <el-button type="primary" @click="createOrUpdate()" :disabled="!isFormValid || isSubmitting">
            <i class="mdi mdi-content-save" />
            新規作成
          </el-button>
        </div>
        <div v-if="campaignPrize.id" layout layout-align="space-between">
          <el-button type="default" @click="deleteCampaignPrize()" :disabled="isDeleteDisabled">
            <i class="mdi mdi-delete-forever" />
            削除
          </el-button>
          <el-button type="primary" @click="createOrUpdate" :disabled="!isFormValid || isSubmitting">
            <i class="mdi mdi-content-save" />
            保存
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.input-container {
  width: 100%;

  &:not(:last-child) {
    margin-bottom: $spacing-unit * 2;
  }

  .label {
    margin-bottom: $spacing-unit;
    font-weight: bold;
  }

  .mdi-help-circle {
    margin-left: $spacing-unit;
    font-size: 20px;
  }

  .el-input-number {
    width: $spacing-unit * 18;
  }

  .label-keyword {
    font-size: $font-small-size;
  }
}

.setting-content:not(:last-child) {
  margin-bottom: $spacing-unit * 2;
}

.caption {
  margin: $spacing-unit * 4 0 $spacing-unit * 2 0;

  &:first-child {
    margin-top: 0;
  }
}

.condition-item .label {
  margin-bottom: $spacing-unit;
}

.keyword-list > div {
  display: inline-block;
}

.badge.badge-danger.twitter {
  position: initial;
  display: inline-block;
  font-weight: 100;
}

.campaign-create-condition {
  margin-top: $spacing-unit * 2;
}

.web-instanwin-page-media {
  width: 100%;
}

.web-instanwin-page .input-container {
  display: flex;
  margin-top: $spacing-unit * 2;
}

.web-instanwin-page .label {
  width: 40%;
}

.direct-media {
  max-width: 100%;
  max-height: $spacing-unit * 32;
}

.media-preview {
  position: relative;
  display: inline-block;
  padding: math.div($spacing-unit, 2) $spacing-unit;
  border: 1px solid $border-color;
  border-radius: $round;

  &.disabled-media {
    pointer-events: none;
    -webkit-user-select: none;
    user-select: none;
    opacity: 0.6;
    filter: blur(1px);
  }

  .media-name {
    padding-right: $spacing-unit * 3;
  }

  .mdi {
    position: absolute;
    top: math.div($spacing-unit, 2);
    right: math.div($spacing-unit, 2);
    cursor: pointer;
  }
}

.media-limit-text {
  display: block;
  margin-top: $spacing-unit;
}

.title-input-error {
  flex: 76%;
  margin-top: $spacing-unit;
  color: $danger-color;
}

.error-container {
  display: flex;
}

.empty-label {
  flex: 30%;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment-timezone'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import EditableComponent from '@/client/components/_atoms/editable/editable.vue'
import MessageConvert from '@/client/components/_atoms/message_convert'
import Panel from '@/client/components/_atoms/Panel.vue'
import TagInput from '@/client/components/_atoms/tag_input'
import FormItemLabel from '@/client/components/_molecules/FormItemLabel.vue'
import {
  CAMPAIGN_STATUS,
  WEB_INSTANTWIN_DEFAULT_LOADING_MESSAGE,
  WEB_INSTANTWIN_MEDIA_LOADING_ORIGIN_NAME,
  WEB_INSTANTWIN_MEDIA_LOADING_URL
} from '@/client/constant'
import api from '@/client/core/api'
import TwitterUpload from '@/client/core/twitter_upload'
import { TrackingService } from '@/client/services'
import { useTwitterCampaignPrizeStore } from '@/client/store/useTwitterCampaignPrizeStore'
import { validateKeywords } from '@/client/utils/validation/keyword'
import { isPeriodEndAfterNttAaaSwitchover } from '@/common/utils'

export default defineComponent({
  props: {
    prizeCount: Number
  },
  components: {
    TagInput,
    Panel,
    FormItemLabel,
    MessageConvert,
    EditableComponent
  },
  data() {
    return {
      title: '',
      visible: false,
      loading: false,
      isLoading: false,
      campaignPrize: {
        id: 0,
        campaignId: 0,
        name: '',
        maxWinnerCount: 0,
        oldMaxWinnerCount: 0,
        dailyWinnerCount: 0,
        winningRateChangeType: 'none',
        winningRate: 0,
        isDailyLottery: false,
        dailyWinnerChangeTime: '00:00',
        entryKeywords: [],
        commentKeywords: [],
        pageLoadingMediaType: 0,
        pageLoadingMediaUrl: WEB_INSTANTWIN_MEDIA_LOADING_URL,
        pageLoadingMediaOriginName: WEB_INSTANTWIN_MEDIA_LOADING_ORIGIN_NAME,
        pageLoadingText: WEB_INSTANTWIN_DEFAULT_LOADING_MESSAGE
      },
      rawCampaignPrizeData: {},
      errorEntryKeywordMessage: '',
      isSubmitting: false,
      isSubmited: false,
      timePickerOption: {
        start: '00:00',
        step: '01:00',
        end: '23:00'
      },
      timePicker: {},
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      errors: {
        notInputStartDate: false,
        notInputEndDate: false,
        lessThanCurrentTime: false,
        lessThanStartTime: false,
        lessThanCurrentTimeForEnd: false
      },
      datePickerOption: {
        disabledDate() {
          return false
        }
      },
      isSelectingStartTime: true
    }
  },
  computed: {
    ...mapState(useTwitterCampaignPrizeStore, {
      campaign: state => state.campaign ?? {},
      searchKeyword: state => {
        if (state.campaign && state.campaign.setting) {
          return JSON.parse(state.campaign.setting.searchKeyword)
        }
        return null
      },
      orKeyword: state => {
        if (state.campaign && state.campaign.setting && state.campaign.setting.orKeyword) {
          return JSON.parse(state.campaign.setting.orKeyword)
        }
        return null
      },
      commentKeyword: state => {
        if (state.campaign && state.campaign.setting && state.campaign.setting.commentKeyword) {
          return JSON.parse(state.campaign.setting.commentKeyword)
        }
        return null
      }
    }),

    isFormValid() {
      if (!this.timeValid) {
        return false
      }

      if (!this.campaignPrize.name || !this.campaignPrize.pageLoadingText) {
        return false
      }

      return true
    },

    isCheckEmptyNameText() {
      return !this.campaignPrize.name
    },
    isCheckEmptyLoadingText() {
      return !this.campaignPrize.pageLoadingText
    },

    isCampaignFinished() {
      return [CAMPAIGN_STATUS.DURING_FINAL_COLLECTION, CAMPAIGN_STATUS.COLLECTION_COMPLETED].includes(
        this.campaign.status
      )
    },

    isDeleteDisabled() {
      return this.isCampaignFinished || this.prizeCount === 1
    },

    isFormChanged(): boolean {
      return JSON.stringify(this.campaignPrizeData) !== JSON.stringify(this.rawCampaignPrizeData)
    },

    campaignPrizeData() {
      return this.setCampaignPrizeData()
    },

    isIncludeQuoteTweets() {
      if (!this.campaign || !this.campaign.setting || !this.campaign.setting.entryActionType) {
        return false
      }

      return ['retweet_and_quote_tweet', 'quote_tweet'].includes(this.campaign.setting.entryActionType)
    },

    // リポスト系（公式リポスト・引用・リポスト&引用）か。応募収集URL 設定で登録したポストを判定対象とする種別。
    isRepostBasedType() {
      if (!this.campaign || !this.campaign.setting || !this.campaign.setting.entryActionType) {
        return false
      }

      return ['retweet', 'quote_tweet', 'retweet_and_quote_tweet'].includes(this.campaign.setting.entryActionType)
    },

    isCampaignPostKeywordTarget() {
      if (this.campaign.type !== 'keyword' || !this.isRepostBasedType) {
        return false
      }

      if (!this.campaign.endDatetime) {
        return false
      }

      return isPeriodEndAfterNttAaaSwitchover(this.campaign.endDatetime)
    },

    quoteKeywordText() {
      if (!this.campaign || !this.campaign.setting || !this.campaign.setting.entryActionType) {
        return ''
      }

      return this.campaign.setting.entryActionType === 'quote_tweet'
        ? '引用のコメントに以下のキーワードを含む'
        : '引用の場合、コメントに以下のキーワードを含む'
    },

    isUploadMediaLoadingType() {
      return !!this.campaignPrize.pageLoadingMediaType
    },

    timeValid() {
      const startTime = this.startTime || '00:00'
      const endTime = this.endTime || '00:00'
      const startDatetime = `${this.startDate} ${startTime}`
      const endDatetime = `${this.endDate} ${endTime}`

      // 開始日が未入力エラー
      if (this.startTime && !this.startDate) {
        this.errors.notInputStartDate = true
      } else {
        this.errors.notInputStartDate = false
      }

      if (this.startDate && this.campaign.status === CAMPAIGN_STATUS.BEFORE_EVENT) {
        this.errors.lessThanCurrentTime = startDatetime < moment().format('YYYY-MM-DD HH:mm')

        // CP開始前の日時を指定できない
        if (this.campaign.status === CAMPAIGN_STATUS.BEFORE_EVENT) {
          const campaignStartTime = moment(this.campaign.startDatetime)

          if (
            startDatetime < campaignStartTime.format('YYYY-MM-DD HH:mm') &&
            !this.errors.lessThanCurrentTime &&
            this.startTime
          ) {
            this.startTime = campaignStartTime.format('HH:mm')
          }
        }

        // CP終了後の日時を指定できない
        const campaignEndDateTime = moment(this.campaign.endDatetime)

        if (
          startDatetime > campaignEndDateTime.format('YYYY-MM-DD HH:mm') &&
          !this.errors.lessThanCurrentTime &&
          this.startTime
        ) {
          this.startTime = campaignEndDateTime.format('HH:mm')
        }
      } else {
        this.errors.lessThanStartTime = false
        this.errors.lessThanCurrentTime = false
      }

      // 終了日が未入力エラー
      if (this.endTime && !this.endDate) {
        this.errors.notInputEndDate = true
      } else {
        this.errors.notInputEndDate = false
      }

      // 終了日時が開始日時より前で指定した場合エラー
      if (this.endDate) {
        if (this.startDate) {
          this.errors.lessThanStartTime = endDatetime < startDatetime
        } else {
          this.errors.lessThanStartTime = false
          this.errors.lessThanCurrentTimeForEnd = endDatetime < moment().format('YYYY-MM-DD HH:mm')
        }

        // CP終了後の日時を指定できない
        const campaignEndDateTime = moment(this.campaign.endDatetime)
        if (
          endDatetime > campaignEndDateTime.format('YYYY-MM-DD HH:mm') &&
          !this.errors.lessThenStartTime &&
          this.endTime
        ) {
          this.endTime = campaignEndDateTime.format('HH:mm')
        }

        // CP開始前の日時を指定できない
        const campaignStartDateTime = moment(this.campaign.startDatetime)
        if (this.campaign.status === CAMPAIGN_STATUS.BEFORE_EVENT) {
          if (
            endDatetime < campaignStartDateTime.format('YYYY-MM-DD HH:mm') &&
            !this.errors.lessThenStartTime &&
            !this.errors.lessThanCurrentTimeForEnd &&
            this.endTime
          ) {
            this.endTime = campaignStartDateTime.format('HH:mm')
          }
        }
      } else {
        this.errors.lessThanStartTime = false
        this.errors.lessThanCurrentTimeForEnd = false
      }

      return (
        !this.errors.notInputStartDate &&
        !this.errors.lessThanCurrentTime &&
        !this.errors.notInputEndDate &&
        !this.errors.lessThanStartTime &&
        !this.errors.lessThanCurrentTimeForEnd
      )
    },

    selectedDate() {
      return this.isSelectingStartTime ? this.startDate : this.endDate
    }
  },
  watch: {
    campaign() {
      this.updateDatePickerOption()
    },

    selectedDate(newVal: string) {
      this.updateTimePicker(newVal)
    }
  },
  methods: {
    ...mapActions(useTwitterCampaignPrizeStore, ['fetchPrizes', 'fetchCampaign']),

    /**
     * メディアファイル削除
     */
    async removeMedia() {
      this.campaignPrize.pageLoadingMediaUrl = null
      this.campaignPrize.pageLoadingMediaType = 0
      this.campaignPrize.pageLoadingMediaOriginName = null
    },

    /**
     * ファイルを変更
     */
    async handleFileChange(e) {
      TrackingService.sendEvent('click:応募グループ一覧|応募グループの編集(X)|アップロード')

      if (!e.target.files || !e.target.files[0]) {
        return
      }

      this.isLoading = true

      const validFormat = ['video/mp4', 'image/jpeg', 'image/png', 'image/gif', 'image/pjpeg', 'image/gif']

      // メディアをチェック

      const file = e.target.files[0]

      const checkValidMedia = await TwitterUpload.checkValidMedia(file, validFormat)

      if (checkValidMedia.error) {
        const error = checkValidMedia.error

        let title = ''
        let message = ''

        switch (error) {
          case 'INVALID_MEDIA':
            title = 'Please upload valid format!'
            message = validFormat.join(', ')
            break
          case 'MAX_SIZE_VIDEO':
            title = '25MB以上のビデオを利用することはできません。 サイズを調整してからアップロードしてください。'
            break
          case 'MAX_SIZE_IMAGE':
            title = '5MB以上の画像を利用することはできません。サイズを調整してからアップロードしてください。'
            break
          case 'INVALID_DIMENSION':
            title = '画像・動画アップロードに失敗しました。'
            message =
              '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'
            break
        }

        this.pageLoadingMediaType = null
        this.showError(title, message)

        return
      }

      const formData = new FormData()
      formData.append('file', file)

      const data = await api.post('/media_uploads', formData, {
        headers: {
          'Content-Type': undefined
        }
      })

      this.page_main_image_url = data.data.media_url

      const mediaType = file.type === 'video/mp4' ? 1 : 0

      this.campaignPrize.pageLoadingMediaUrl = data.data.media_url
      this.campaignPrize.pageLoadingMediaOriginName = file.name
      this.campaignPrize.pageLoadingMediaType = mediaType

      this.isLoading = false
    },

    /**
     * ページ落選時テキストを設定
     */
    async setPageLoadingText(value: string) {
      TrackingService.sendEvent('input:応募グループ一覧|応募グループの編集(X)|抽選中テキスト')
      this.campaignPrize.pageLoadingText = value
    },

    /**
     * Set campaign prize data
     * @returns {Object} campaign prize data
     */
    setCampaignPrizeData() {
      return {
        campaignId: this.campaignPrize.campaignId,
        name: this.campaignPrize.name,
        maxWinnerCount: this.campaignPrize.maxWinnerCount,
        oldMaxWinnerCount: this.campaignPrize.maxWinnerCount,
        dailyWinnerCount: this.campaignPrize.dailyWinnerCount,
        winningRateChangeType: this.campaignPrize.winningRateChangeType,
        winningRate: this.campaignPrize.winningRateChangeType === 'auto' ? 0 : this.campaignPrize.winningRate,
        isDailyLottery: this.campaignPrize.isDailyLottery,
        dailyWinnerChangeTime: this.campaignPrize.dailyWinnerChangeTime,
        startDatetime: this.campaignPrize.startDatetime,
        endDatetime: this.campaignPrize.endDatetime,
        entryKeyword: JSON.stringify(this.campaignPrize.entryKeywords),
        commentKeyword: JSON.stringify(this.campaignPrize.commentKeywords),
        pageLoadingMediaType: this.campaignPrize.pageLoadingMediaType,
        pageLoadingMediaUrl: this.campaignPrize.pageLoadingMediaUrl ?? WEB_INSTANTWIN_MEDIA_LOADING_URL,
        pageLoadingMediaOriginName: this.campaignPrize.pageLoadingMediaOriginName ?? WEB_INSTANTWIN_MEDIA_LOADING_URL,
        pageLoadingText: this.campaignPrize.pageLoadingText ?? WEB_INSTANTWIN_DEFAULT_LOADING_MESSAGE
      }
    },

    /**
     * Get data from api
     */
    async getCampaignPrize() {
      this.loading = true
      const result = await api.get('/twitter_campaign_prizes/' + this.campaignPrize.id)
      this.loading = false
      const campaignPrize = result.data

      if (!campaignPrize) {
        this.$notify({
          title: '対象の応募グループはすでに削除されています。',
          customClass: 'danger',
          duration: 5000
        })
        this.close()
        return
      }

      this.campaignPrize = {
        id: campaignPrize.id,
        campaignId: campaignPrize.campaignId,
        name: campaignPrize.name,
        maxWinnerCount: campaignPrize.maxWinnerCount,
        oldMaxWinnerCount: campaignPrize.maxWinnerCount,
        dailyWinnerCount: campaignPrize.dailyWinnerCount ?? 0,
        winningRateChangeType: campaignPrize.winningRateChangeType ?? 'none',
        winningRate: campaignPrize.winningRate ?? 0,
        isDailyLottery: campaignPrize.isDailyLottery ?? false,
        dailyWinnerChangeTime: campaignPrize.dailyWinnerChangeTime
          ? campaignPrize.dailyWinnerChangeTime.substring(0, 5)
          : null,
        startDatetime: campaignPrize.startDatetime ?? null,
        endDatetime: campaignPrize.endDatetime ?? null,
        pageLoadingMediaUrl: campaignPrize.pageLoadingMediaUrl ?? WEB_INSTANTWIN_MEDIA_LOADING_URL,
        pageLoadingMediaOriginName:
          campaignPrize.pageLoadingMediaOriginName ?? WEB_INSTANTWIN_MEDIA_LOADING_ORIGIN_NAME,
        pageLoadingText: campaignPrize.pageLoadingText ?? WEB_INSTANTWIN_DEFAULT_LOADING_MESSAGE,
        pageLoadingMediaType: campaignPrize.pageLoadingMediaType,
        entryKeywords: campaignPrize.entryKeyword ? JSON.parse(campaignPrize.entryKeyword) : [],
        commentKeywords: campaignPrize.commentKeyword ? JSON.parse(campaignPrize.commentKeyword) : []
      }

      if (campaignPrize.startDatetime) {
        this.startDate = moment(campaignPrize.startDatetime).format('YYYY-MM-DD')
        this.startTime = moment(campaignPrize.startDatetime).format('HH:mm')
      }

      if (campaignPrize.endDatetime) {
        this.endDate = moment(campaignPrize.endDatetime).format('YYYY-MM-DD')
        this.endTime = moment(campaignPrize.endDatetime).format('HH:mm')
      }
    },

    async createOrUpdate() {
      if (this.campaignPrize.id) {
        TrackingService.sendEvent('click:応募グループ一覧|応募グループの編集(X)|保存')

        await this.updateCampaignPrize()
      } else {
        await this.createCampaignPrize()
      }
      this.close()
    },

    /**
     * 応募グループの新規作成
     */
    async createCampaignPrize() {
      this.isSubmitting = true
      if (!this.isFormValid) {
        return
      }

      this.campaignPrizeData.startDatetime = this.formatDateTime(this.startDate, this.startTime)
      this.campaignPrizeData.endDatetime = this.formatDateTime(this.endDate, this.endTime)

      // キャンペーンを保存する
      const result = await api.post('/twitter_campaign_prizes', this.campaignPrizeData)

      setTimeout(() => {
        this.isSubmitting = false
      }, 2000)

      if (result && result.data) {
        // 成功メッセージを表示
        this.$notify({
          title: '応募グループを作成しました。',
          customClass: 'success',
          duration: 5000
        })
        return
      }

      this.$notify({
        title: '応募グループの新規作成に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
    },

    /**
     * 応募グループの編集
     */
    async updateCampaignPrize() {
      this.isSubmitting = true
      if (!this.isFormValid) {
        return
      }

      this.campaignPrizeData.startDatetime = this.formatDateTime(this.startDate, this.startTime)
      this.campaignPrizeData.endDatetime = this.formatDateTime(this.endDate, this.endTime)

      // キャンペーンを保存する
      const result = await api.put('/twitter_campaign_prizes/' + this.campaignPrize.id, this.campaignPrizeData)

      setTimeout(() => {
        this.isSubmitting = false
      }, 2000)

      if (result && result.data) {
        // 成功メッセージを表示
        this.$notify({
          title: '応募グループを保存しました。',
          customClass: 'success',
          duration: 5000
        })

        return
      }

      if (result.error && result.error.type === 'NOT_EXISTS') {
        this.$notify({
          title: '対象の応募グループはすでに削除されています。',
          customClass: 'danger',
          duration: 5000
        })

        return
      }

      this.$notify({
        title: '応募グループの保存に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
    },

    /**
     * 応募グループの削除
     */
    async deleteCampaignPrize() {
      TrackingService.sendEvent('click:応募グループ一覧|応募グループの編集(X)|削除')

      const confirmDelete = confirm('応募グループを削除してよろしいですか？')
      if (!confirmDelete) {
        return
      }

      const result = await api.delete('/twitter_campaign_prizes/' + this.campaignPrize.id)

      if (result && result.data) {
        this.$notify({
          title: '応募グループを削除しました。',
          customClass: 'success',
          duration: 5000
        })
        this.close()
        return
      }

      if (result.error && result.error.type === 'NOT_EXISTS') {
        this.$notify({
          title: '対象の応募グループはすでに削除されています。',
          customClass: 'danger',
          duration: 5000
        })
        this.close()
        return
      }

      this.$notify({
        title: '応募グループの削除に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
      this.close()
    },

    /**
     * Execute when max winner count is changed
     * @param {number} maxWinnerCount
     */
    onChangeMaxWinnerCount(maxWinnerCount: number) {
      if (maxWinnerCount === this.campaignPrize.oldMaxWinnerCount + 1) {
        TrackingService.sendEvent('click:応募グループ一覧|応募グループの編集(X)|当選数|UP')
      } else if (maxWinnerCount === this.campaignPrize.oldMaxWinnerCount - 1) {
        TrackingService.sendEvent('click:応募グループ一覧|応募グループの編集(X)|当選数|DOWN')
      } else TrackingService.sendEvent('input:応募グループ一覧|応募グループの編集(X)|当選数')

      this.campaignPrize.oldMaxWinnerCount = this.campaignPrize.maxWinnerCount

      if (!maxWinnerCount) {
        setTimeout(() => {
          this.campaignPrize.maxWinnerCount = 0
        }, 100)
      }

      if (maxWinnerCount < this.campaignPrize.dailyWinnerCount) {
        setTimeout(() => {
          this.campaignPrize.dailyWinnerCount = 0
        }, 100)
      }
    },

    /**
     * Execute when daily winner count is changed
     * @param {number} dailyWinnerCount
     */
    onChangeDailyWinnerCount(dailyWinnerCount: number) {
      if (!dailyWinnerCount) {
        setTimeout(() => {
          this.campaignPrize.dailyWinnerCount = 0
        }, 100)

        return
      }

      if (dailyWinnerCount > this.campaignPrize.maxWinnerCount) {
        setTimeout(() => {
          this.campaignPrize.dailyWinnerCount = 0
        }, 100)
      }
    },

    onChangeWinningRate(winningRate: number) {
      if (!winningRate) {
        setTimeout(() => {
          this.campaignPrize.winningRate = 0
        }, 100)
      }
    },

    /**
     * Valid entry keyword
     * @param {string[]} keywords list keyword
     */
    onChangeEntryKeywords(keywords: string[]) {
      const origin = [...this.campaignPrize.entryKeywords]

      if (!this.isValidKeyword(keywords, origin)) {
        this.campaignPrize.entryKeywords = origin
        return
      }
      this.errorEntryKeywordMessage = ''
      this.campaignPrize.entryKeywords = keywords
    },

    /**
     * コメントキーワードの更新
     */
    onChangeCommentKeywords(keywords: string[]) {
      const origin = [...this.campaignPrize.commentKeywords]

      if (!this.isValidKeyword(keywords, origin)) {
        this.campaignPrize.commentKeywords = origin
        return
      }
      this.errorEntryKeywordMessage = ''
      this.campaignPrize.commentKeywords = keywords
    },

    /**
     * Check if keyword is valid
     * @param {string[]} keywords list keyword
     * @param {string} origin
     * @returns {boolean}
     */
    isValidKeyword(keywords: string[], origin: string[]): boolean {
      const result = validateKeywords(keywords, origin)

      if (!result.isValid) {
        this.errorEntryKeywordMessage = result.errorMessage
        this.$notify({
          title: result.errorMessage,
          customClass: 'danger',
          duration: 5000
        })
      }

      return result.isValid
    },

    /**
     * ダイアログを開く
     */
    async open(campaignId: number, id: number) {
      this.visible = true
      if (id) {
        this.campaignPrize.id = id
        this.title = '応募グループの編集'
        await this.getCampaignPrize()
      } else {
        this.title = '応募グループの新規作成'
      }

      this.campaignPrize.campaignId = campaignId
      this.rawCampaignPrizeData = this.setCampaignPrizeData()
    },

    /**
     * Close dialog after submit
     * @returns {Promise<void>} void
     */
    async close(): Promise<void> {
      this.isSubmited = true
      this.visible = false
      await this.fetchPrizes()
      await this.fetchCampaign()
    },

    /**
     * Close dialog
     * @returns {void}: void
     */
    hide(): void {
      TrackingService.sendEvent('click:応募グループ一覧|応募グループの編集(X)|閉じる')

      this.resetForm()
      this.visible = false
      this.loading = false
      this.isSubmited = false
    },

    resetForm() {
      this.campaignPrize = {
        id: 0,
        campaignId: 0,
        name: '',
        maxWinnerCount: 0,
        dailyWinnerCount: 0,
        winningRateChangeType: 'none',
        winningRate: 0,
        isDailyLottery: false,
        entryKeywords: [],
        commentKeywords: [],
        pageLoadingMediaType: 0,
        pageLoadingMediaUrl: WEB_INSTANTWIN_MEDIA_LOADING_URL,
        pageLoadingMediaOriginName: WEB_INSTANTWIN_MEDIA_LOADING_ORIGIN_NAME,
        pageLoadingText: WEB_INSTANTWIN_DEFAULT_LOADING_MESSAGE
      }
      this.errorEntryKeywordMessage = ''
      this.startDate = ''
      this.startTime = ''
      this.endDate = ''
      this.endTime = ''
    },

    formatDateTime(date, time, defaultTime = '00:00') {
      if (date) {
        const timeValue = time || defaultTime
        return moment(`${date} ${timeValue}`).format()
      }
      return null
    },

    updateDatePickerOption() {
      this.datePickerOption = {
        disabledDate: time => {
          const currentDate = moment(time.getTime()).format('YYYY-MM-DD')
          const campaignStartDate = this.campaign.startDatetime
            ? moment(this.campaign.startDatetime).format('YYYY-MM-DD')
            : null
          const campaignEndDate = this.campaign.endDatetime
            ? moment(this.campaign.endDatetime).format('YYYY-MM-DD')
            : null

          if (campaignStartDate > moment().format('YYYY-MM-DD')) {
            return currentDate < campaignStartDate || currentDate > campaignEndDate
          }

          return currentDate < moment().format('YYYY-MM-DD') || currentDate > campaignEndDate
        }
      }
    },

    updateTimePicker(selectedDate) {
      if (!selectedDate) {
        this.timePicker = {
          start: '00:00',
          step: '01:00',
          end: '23:59'
        }
        return
      }

      const campaignStartDate = this.campaign.startDatetime
        ? moment(this.campaign.startDatetime).format('YYYY-MM-DD')
        : null
      const campaignEndDate = this.campaign.endDatetime ? moment(this.campaign.endDatetime).format('YYYY-MM-DD') : null

      const campaignStartTime = this.campaign.startDatetime
        ? this.roundUpToNextHour(moment(this.campaign.startDatetime).format('HH:mm'))
        : '00:00'
      const campaignEndTime = this.campaign.endDatetime ? moment(this.campaign.endDatetime).format('HH:mm') : '23:59'

      const currentDate = moment().format('YYYY-MM-DD')
      const currentTime = this.roundUpToNextHour(moment().format('HH:mm'))

      if (moment(selectedDate).isSame(campaignStartDate)) {
        this.timePicker = {
          start: campaignStartTime < currentTime && selectedDate === currentDate ? currentTime : campaignStartTime,
          step: '01:00',
          end: '23:59'
        }
      } else if (moment(selectedDate).isSame(campaignEndDate)) {
        this.timePicker = {
          start: '00:00',
          step: '01:00',
          end: campaignEndTime
        }
      } else if (moment(selectedDate).isSame(currentDate)) {
        this.timePicker = {
          start: currentTime,
          step: '01:00',
          end: '23:59'
        }
      } else {
        this.timePicker = {
          start: '00:00',
          step: '01:00',
          end: '23:59'
        }
      }
    },

    roundUpToNextHour(timeStr) {
      const targetTime = moment(timeStr, 'HH:mm')

      if (targetTime.minute() > 0) {
        targetTime.add(1, 'hour').minute(0)
      }

      return targetTime.format('HH:mm')
    }
  }
})
</script>
